import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import STRtree from '../index/strtree/STRtree';
import NodedSegmentString from './NodedSegmentString';
import MonotoneChainOverlapAction from '../index/chain/MonotoneChainOverlapAction';
import MonotoneChainBuilder from '../index/chain/MonotoneChainBuilder';
import ArrayList from '../../../../java/util/ArrayList';
import SinglePassNoder from './SinglePassNoder';
var MCIndexNoder = /*#__PURE__*/function (_SinglePassNoder) {
  _inherits(MCIndexNoder, _SinglePassNoder);
  function MCIndexNoder() {
    var _this;
    _classCallCheck(this, MCIndexNoder);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MCIndexNoder).call(this));
    MCIndexNoder.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(MCIndexNoder, [{
    key: "getMonotoneChains",
    value: function getMonotoneChains() {
      return this._monoChains;
    }
  }, {
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      return NodedSegmentString.getNodedSubstrings(this._nodedSegStrings);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._index;
    }
  }, {
    key: "add",
    value: function add(segStr) {
      var segChains = MonotoneChainBuilder.getChains(segStr.getCoordinates(), segStr);
      for (var i = segChains.iterator(); i.hasNext();) {
        var mc = i.next();
        mc.setId(this._idCounter++);
        this._index.insert(mc.getEnvelope(), mc);
        this._monoChains.add(mc);
      }
    }
  }, {
    key: "computeNodes",
    value: function computeNodes(inputSegStrings) {
      this._nodedSegStrings = inputSegStrings;
      for (var i = inputSegStrings.iterator(); i.hasNext();) this.add(i.next());
      this.intersectChains();
    }
  }, {
    key: "intersectChains",
    value: function intersectChains() {
      var overlapAction = new SegmentOverlapAction(this._segInt);
      for (var i = this._monoChains.iterator(); i.hasNext();) {
        var queryChain = i.next();
        var overlapChains = this._index.query(queryChain.getEnvelope());
        for (var j = overlapChains.iterator(); j.hasNext();) {
          var testChain = j.next();
          if (testChain.getId() > queryChain.getId()) {
            queryChain.computeOverlaps(testChain, overlapAction);
            this._nOverlaps++;
          }
          if (this._segInt.isDone()) return null;
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._monoChains = new ArrayList();
      this._index = new STRtree();
      this._idCounter = 0;
      this._nodedSegStrings = null;
      this._nOverlaps = 0;
      if (arguments.length === 0) {} else if (arguments.length === 1) {
        var si = arguments[0];
        SinglePassNoder.constructor_.call(this, si);
      }
    }
  }]);
  return MCIndexNoder;
}(SinglePassNoder);
export { MCIndexNoder as default };
var SegmentOverlapAction = /*#__PURE__*/function (_MonotoneChainOverlap) {
  _inherits(SegmentOverlapAction, _MonotoneChainOverlap);
  function SegmentOverlapAction() {
    var _this2;
    _classCallCheck(this, SegmentOverlapAction);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SegmentOverlapAction).call(this));
    SegmentOverlapAction.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this2)), arguments);
    return _this2;
  }
  _createClass(SegmentOverlapAction, [{
    key: "overlap",
    value: function overlap() {
      if (arguments.length === 4) {
        var mc1 = arguments[0],
          start1 = arguments[1],
          mc2 = arguments[2],
          start2 = arguments[3];
        var ss1 = mc1.getContext();
        var ss2 = mc2.getContext();
        this._si.processIntersections(ss1, start1, ss2, start2);
      } else {
        return _get(_getPrototypeOf(SegmentOverlapAction.prototype), "overlap", this).apply(this, arguments);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._si = null;
      var si = arguments[0];
      this._si = si;
    }
  }]);
  return SegmentOverlapAction;
}(MonotoneChainOverlapAction);
MCIndexNoder.SegmentOverlapAction = SegmentOverlapAction;